export default function RedirectWithApiLink(props) {
  window.location.href = props.to;
  return null;
}
